import { useQuery } from '@apollo/client';
import { FeatureFlag } from 'constants-flags';
import { getContentsOnChannels as optimizedContentsOnChannelsQuery } from '../graphql/query/getContentsOnChannels';
import { getContentsOnChannelsQuery } from '../graphql/query';
import { useMultiLanguage } from './useMultiLanguage';
import { useOptimizedContentsOnChannelsQuery } from './useOptimizedContentsOnChannelsQuery';
import useFlag from './useFlag';

export const useMultiChannelContent = ({
  channelIds,
}: {
  channelIds: Array<string>;
}) => {
  const isOptimizedContentsOnChannelsEnabled = useOptimizedContentsOnChannelsQuery();
  const query = isOptimizedContentsOnChannelsEnabled
    ? optimizedContentsOnChannelsQuery
    : getContentsOnChannelsQuery;

  // Content shown here (e.g. Today Feed) doesn't otherwise get refreshed
  // when a UCI is created/updated elsewhere, since this query's Apollo
  // cache entry is never invalidated by those mutations.
  const isMemberInteractionUpdateEnabled = useFlag(
    FeatureFlag.MemberInteractionUpdate,
    false
  );

  const { data } = useQuery(query, {
    variables: { channelIds },
    ...(isMemberInteractionUpdateEnabled
      ? { fetchPolicy: 'cache-and-network' as const }
      : {}),
  });

  const { translate } = useMultiLanguage();

  if (data?.me?.contentsOnChannels) {
    return translate({ model: [...data.me.contentsOnChannels] });
  }

  return [];
};
